import type { Theme } from '@mui/material/styles';

export const useHelpKitModalStyle = (theme: Theme) => ({
  modalTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    pr: 5,
  },
  modalIconBox: {
    width: 36,
    height: 36,
    borderRadius: '8px',
    background: `linear-gradient(135deg, ${theme.palette.custom.danger}, ${theme.palette.custom.dangerLight})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  modalIcon: {
    color: '#fff',
    fontSize: 20,
  },
  modalContent: {
    pt: 0.5,
    pb: 1,
    '& p': {
      margin: 0,
      marginBottom: '0.85em',
      color: theme.palette.custom.gray700,
      fontSize: '0.9375rem',
      lineHeight: 1.75,
      '&:last-child': { marginBottom: 0 },
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      color: theme.palette.custom.gray900,
      fontWeight: 700,
      marginTop: '1.1em',
      marginBottom: '0.35em',
      lineHeight: 1.3,
      '&:first-of-type': { marginTop: 0 },
    },
    '& h1': { fontSize: '1.15rem' },
    '& h2': { fontSize: '1.05rem' },
    '& h3': { fontSize: '0.9375rem' },
    '& h4, & h5, & h6': { fontSize: '0.875rem' },
    '& strong': { fontWeight: 700, color: theme.palette.custom.gray900 },
    '& em': { fontStyle: 'italic' },
    '& p + ul, & p + ol': { marginTop: '-0.5em' },
    '& ul': { listStyle: 'none', padding: 0, margin: 0, marginBottom: '0.85em' },
    '& ul li': {
      position: 'relative',
      paddingLeft: '16px',
      marginBottom: '6px',
      color: theme.palette.custom.gray600,
      fontSize: '0.875rem',
      lineHeight: 1.65,
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '9px',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        background: `linear-gradient(135deg, ${theme.palette.custom.danger}, ${theme.palette.custom.dangerLight})`,
        flexShrink: 0,
      },
    },
    '& ol': { listStyle: 'none', padding: 0, margin: 0, marginBottom: '0.85em', counterReset: 'helpkit-ol' },
    '& ol li': {
      position: 'relative',
      paddingLeft: '30px',
      marginBottom: '8px',
      color: theme.palette.custom.gray600,
      fontSize: '0.875rem',
      lineHeight: 1.65,
      counterIncrement: 'helpkit-ol',
      '&::before': {
        content: 'counter(helpkit-ol)',
        position: 'absolute',
        left: 0,
        top: '2px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        background: `linear-gradient(135deg, ${theme.palette.custom.danger}, ${theme.palette.custom.dangerLight})`,
        color: '#fff',
        fontSize: '0.7rem',
        fontWeight: 700,
      },
    },
    '& li p': { margin: 0, flex: 1, minWidth: 0 },
    '& li br': { display: 'none' },
  },
  bulletList: {
    pl: 0,
    m: 0,
    listStyle: 'none',
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mb: 1,
  },
  bulletDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${theme.palette.custom.danger}, ${theme.palette.custom.dangerLight})`,
    mt: '9px',
    flexShrink: 0,
  },
  bulletText: {
    color: theme.palette.custom.gray600,
    lineHeight: 1.65,
  },
});
